import type { Language } from "../i18n";
import { t } from "../i18n";

export interface SoundToggleProps {
  enabled: boolean;
  onToggle: () => void;
  language?: Language;
}

/**
 * Sound toggle button controlling audio feedback upon barcode detection.
 */
export function SoundToggle({ enabled, onToggle, language = "ru" }: SoundToggleProps) {
  const ariaLabel = enabled
    ? t(language, "sound_aria_on")
    : t(language, "sound_aria_off");
  const label = enabled ? t(language, "sound_on") : t(language, "sound_off");

  return (
    <button
      type="button"
      className={`sound-button ${!enabled ? "sound-button--muted" : ""}`}
      onClick={onToggle}
      aria-label={ariaLabel}
      aria-pressed={enabled}
      data-testid="sound-toggle-button"
    >
      {enabled ? (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
        </svg>
      ) : (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <line x1="23" y1="9" x2="17" y2="15" />
          <line x1="17" y1="9" x2="23" y2="15" />
        </svg>
      )}
      <span>{label}</span>
    </button>
  );
}
